import { PaginationData, PaginationPcApiResponse } from '@/api/pc-api/types';
import { BizType } from '@/constants/bizType';
import { ChargeStatus, ContractSearchStatusType, ContractStatus } from '@/constants/contract';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type ContractListForDealerParams = {
  id: string;
  searchContractDateType: string;
  startedAt: string;
  finishedAt: string;
  name: string;
  productIds: string[];
  searchContractStatusType: ContractSearchStatusType;
  searchContractStatus?: ContractStatus;
  page: number;
  size?: number;
};

export type ContractForDealer = {
  id: string;
  partnerName: string;
  serviceName: string;
  product: {
    id: string;
    code: string;
    description: string;
    isTest: boolean;
  };
  startedAt: string;
  finishedAt: string;
  chargingStartedAt: string;
  chargingFinishedAt: string;
  renewalPeriod: number;
  autoRenewal: boolean;
  contractStatus: ContractStatus;
  chargingStatus: ChargeStatus;
  svcId: string;
  partnerId: string;
  contractStatusDescription: string;
  chargingStatusDescription: string;
  bizType: BizType;
  settleId: string;
  settleName: string;
};

type ContractListForDealer = ContractForDealer[];
export type ContractListForDealerPagination = PaginationData<ContractListForDealer>;

const DEFAULT_PAGE_SIZE = 25;

export const getContractListForDealer = (params: ContractListForDealerParams) => {
  return api<PaginationPcApiResponse<ContractListForDealer>>(
    'get',
    `/pc-api/v1/${PREFIX_PATH}/contract/list/search-for-dealer`,
    {
      ...params,
      size: params.size || DEFAULT_PAGE_SIZE
    }
  );
};
